import { createContext, useEffect, useContext, useReducer } from "react";

const initialImageModalProps = {
    open: false,
    src: null,
};

const ImageModalContext = createContext(null);

export const imageModalReducerActions = {
    SHOW: 0,
    HIDE: 1,
};

function imageModalReducer(state, action) {
    switch (action.type) {
        case imageModalReducerActions.SHOW: {
            return {
                ...state,
                open: true,
                src: action.payload,
            };
        }
        case imageModalReducerActions.HIDE: {
            return { ...initialImageModalProps };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
}

function ImageModalProvider({ children }) {
    const [state, dispatch] = useReducer(
        imageModalReducer,
        initialImageModalProps
    );
    const value = { state, dispatch };

    return (
        <ImageModalContext.Provider value={value}>
            {children}
        </ImageModalContext.Provider>
    );
}

function useImageModalContext() {
    const context = useContext(ImageModalContext);
    if (context === undefined) {
        throw new Error("useCount must be used within a CountProvider");
    }
    return context;
}

export { ImageModalProvider, useImageModalContext };
